import Api from "@services/api";

export const getProductDetailPageAttrs = async (slug: string) => {
  const res = await Api().get(`/products/${slug}?populate=deep`);

  return res.data;
};
